<template>
	<div>
		<Navbar :key="$route.fullPath"/>
		<div  style="padding-top: 66px;">
			<slot></slot>
		</div>
		<Footer/>
	</div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/layout/Navbar.vue";
import Footer from "@/layout/Footer.vue";

export default {
	components: {
		Navbar, 
		Footer
	},
	mounted() { 
		let popper_js = document.createElement('script')
		popper_js.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.5/dist/umd/popper.min.js')
		document.body.appendChild(popper_js)

		let bootstrap_js = document.createElement('script')
		bootstrap_js.setAttribute('src', '/design/js/bootstrap.js')
		document.body.appendChild(bootstrap_js)

		let custom_js = document.createElement('script')
		custom_js.setAttribute('src', '/design/js/custom.js')
		document.body.appendChild(custom_js)
		
	},
}
</script>
